var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSavingsFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.925 21.5q-.575 0-1.112-.4t-.713-.975q-.625-2.1-1.025-3.637a53 53 0 0 1-.638-2.7 23 23 0 0 1-.337-2.063Q2 10.825 2 10q0-2.3 1.6-3.9t3.9-1.6h5q.674-.9 1.713-1.45A4.8 4.8 0 0 1 16.5 2.5q.625 0 1.063.438a1.45 1.45 0 0 1 .4 1.362q-.039.15-.088.275-.101.275-.187.55a4 4 0 0 0-.138.6L19.825 8H21q.424 0 .712.287Q22 8.576 22 9v5.25a.93.93 0 0 1-.187.575 1.13 1.13 0 0 1-.513.375l-2.125.7-1.25 4.175q-.2.65-.725 1.038-.525.387-1.2.387h-2q-.825 0-1.412-.587A1.93 1.93 0 0 1 12 19.5h-2q0 .824-.588 1.413A1.93 1.93 0 0 1 8 21.5zM16 11.5q.424 0 .712-.287A.97.97 0 0 0 17 10.5a.97.97 0 0 0-.288-.713A.97.97 0 0 0 16 9.5a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713q0 .424.287.713.288.287.713.287m-4-2q.424 0 .713-.287A.97.97 0 0 0 13 8.5a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 7.5H9a.97.97 0 0 0-.713.287A.97.97 0 0 0 8 8.5q0 .424.287.713.288.287.713.287z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingsFill);
export default __webpack_public_path__ + "static/media/savings_fill.7c8b7f8b12100a1a5e019aa149dab4a2.svg";
export { ForwardRef as ReactComponent };